module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("DEDICATORY")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("Because he has given me permission to tell my story; because he has read that story and knows I try to speak the truth; because I believe that he is fair-minded and will cause my people to receive justice in the future; and because he is chief of a great people, I dedicate this story of my life to Theodore Roosevelt, President of the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Right"
  }, [_vm._v("Geronimo.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14796c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled11.vue
// module id = 69
// module chunks = 0